import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Col = styled.div<{ $maxWidth?: string }>`
  display: flex;
  max-width: ${({ $maxWidth }) => $maxWidth || 'none'};
  flex-direction: column;
`;

export const RowReverse = styled.div`
  display: flex;
  flex-direction: row-reverse;
`;

export const ColReverse = styled.div`
  display: flex;
  flex-direction: column-reverse;
`;
